import React from 'react';
import { Tag } from 'antd';
import moment from 'moment';
import { ColumnActions, StandardTooltipColumn } from 'components/Table';
import { DATE_FIELD } from 'helper/const';

import capitalize from 'lodash/capitalize';

const recurringRuleColumns = ({
  onEdit,
  onDelete,
  canManageScheduledServices,
}) => {
  const renderDateWithoutTimezoneShift = value => {
    if (!value) return '—';

    const cleanDate = String(value).split('T')[0];
    const displayDate = moment(cleanDate, 'YYYY-MM-DD', true).isValid()
      ? moment(cleanDate, 'YYYY-MM-DD', true).format(DATE_FIELD.FORMAT)
      : '—';

    return (
      <StandardTooltipColumn tooltip={displayDate}>
        {displayDate}
      </StandardTooltipColumn>
    );
  };

  const columns = [
    {
      title: 'Order Type',
      dataIndex: 'order_type',
      render: value => (value ? value.name : '—'),
      width: 220,
    },
    {
      title: 'Frequency',
      dataIndex: 'frequency',
      render: value => capitalize(value || ''),
      width: 120,
    },
    {
      title: 'Next Run At',
      dataIndex: 'next_run_at',
      render: renderDateWithoutTimezoneShift,
      width: 160,
    },
    {
      title: 'Active',
      dataIndex: 'active',
      render: value =>
        value ? <Tag color="green">Yes</Tag> : <Tag color="default">No</Tag>,
      width: 90,
    },
    {
      title: 'Auto Submit',
      dataIndex: 'auto_submit',
      render: value =>
        value ? <Tag color="blue">Yes</Tag> : <Tag color="default">No</Tag>,
      width: 110,
    },
  ];

  if (canManageScheduledServices) {
    columns.push({
      title: 'Actions',
      width: 100,
      render: (_value, record) => {
        const actions = [
          {
            label: 'Edit',
            props: {
              onClick: () => onEdit(record),
            },
          },
          {
            label: 'Delete',
            props: {
              onClick: () => onDelete(record),
              style: { color: '#ff4d4f' },
            },
          },
        ];
        return <ColumnActions trigger={['click']} actions={actions} />;
      },
    });
  }

  return columns;
};

export { recurringRuleColumns };
